module.exports = __webpack_public_path__ + "static/img/081.6e2a340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/081.png
// module id = IyfJ
// module chunks = 37